module.exports = __webpack_public_path__ + "static/media/tarot-card-13.bd2da9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/tarotcards/tarot-card-13.jpg
// module id = 1342
// module chunks = 0